var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.665,
    height: 96.859,
    viewBox: "0 0 96.665 96.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_61785",
    "data-name": "Group 61785",
    transform: "translate(-949.235 -868.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glyph",
    transform: "translate(949.235 884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159029",
    "data-name": "Path 159029",
    d: "M61.063,33.808a7.356,7.356,0,0,0-10.372,0L33.808,50.69l-9.526-9.526a7.356,7.356,0,0,0-10.372,0L1,54.074V19.39A18.39,18.39,0,0,1,19.39,1H63.527a18.39,18.39,0,0,1,18.39,18.39V54.663ZM23.068,19.39a5.517,5.517,0,1,0,5.517,5.517A5.517,5.517,0,0,0,23.068,19.39ZM1,64.373A18.39,18.39,0,0,0,19.39,81.917H63.527a18.39,18.39,0,0,0,18.39-16.993L56.171,39.178,39.289,56.06a7.356,7.356,0,0,1-10.372,0L19.39,46.534Z",
    transform: "translate(-1 -1)",
    fill: "#a8a8a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61782",
    "data-name": "Group 61782",
    transform: "translate(-78.848 1.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    d: "M18.787,9.15a6,6,0,0,1,10.426,0l13.676,24a6,6,0,0,1-5.213,8.97H10.324a6,6,0,0,1-5.213-8.97Z",
    transform: "translate(1080 861)",
    fill: "#b5b5b5",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221157",
    "data-name": "Path 221157",
    d: "M1791.933,2763.1h2.895a.545.545,0,0,1,.563.537l-.6,10.348a.563.563,0,0,1-.563.537h-1.7a.563.563,0,0,1-.563-.537l-.6-10.348a.543.543,0,0,1,.563-.537Zm1.448,12.511a1.6,1.6,0,1,1-1.677,1.6,1.645,1.645,0,0,1,1.677-1.6Zm0,0",
    transform: "translate(-689.369 -1883.957)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewEmpty);
export default __webpack_public_path__ + "static/media/reviewEmpty.2812ff7d86a9b499228bf3296466a3b4.svg";
export { ForwardRef as ReactComponent };